import React, { useEffect, useState } from "react";
import SummaryAccordion from "./SummaryAccordion";
import { _functionHelper } from "../HelperFunction/HelperFunction";

export default function InspectionSummaryIndex({
  blocksList,
  handleSaveInspection,
  chapterList,
  isInspectionRequired,
  inspectionImage,
  handleSummaryAction,
  equipmentDetails,
  setIsEquipmentNio,
  handleAbort,
  isEquipmentNio,
  handleCreateTicketCheckboxChange,
  showCanCreateTicketCheckbox,
  isCreateTicketActive,
}) {
  const [summaryData, setSummaryData] = useState("");

  useEffect(() => {
    const _tempSummary = _functionHelper.summaryResult(chapterList);
    setSummaryData(_tempSummary);
  }, [blocksList]);

  return (
    summaryData !== "" && (
      <SummaryAccordion
        summaryData={summaryData}
        handleSaveInspection={handleSaveInspection}
        isInspectionRequired={isInspectionRequired}
        inspectionImage={inspectionImage}
        handleSummaryAction={handleSummaryAction}
        equipmentDetails={equipmentDetails}
        setIsEquipmentNio={setIsEquipmentNio}
        isEquipmentNio={isEquipmentNio}
        handleAbort={handleAbort}
        handleCreateTicketCheckboxChange={handleCreateTicketCheckboxChange}
        showCanCreateTicketCheckbox={showCanCreateTicketCheckbox}
        isCreateTicketActive={isCreateTicketActive}
      />
    )
  );
}
